module.exports = __webpack_public_path__ + "static/img/app-bg.bd9065c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-bg.png
// module id = 2Otq
// module chunks = 1